/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationExcerptData } from '../definitions';
import type HubspotPlatform from '../../hubspot';

export default class HubspotConversationExcerpt implements ConversationExcerptData {
  private platform: HubspotPlatform;

  constructor(platform: HubspotPlatform) {
    this.platform = platform;
  }

  title(excerptsEnabled: boolean) {
    let defaultPrefix = 'fin-ai-agent.knowledge.content-sources.conversation-excerpts';
    let prefix = excerptsEnabled ? `${defaultPrefix}.enabled` : defaultPrefix;
    return this.platform.intl.t(`${prefix}.default`);
  }

  get link() {
    return undefined;
  }
}
